

export const index = 8;
export const component = async () => (await import('../entries/pages/solutions-hebergees/_page.svelte.js')).default;
export const file = '_app/immutable/components/pages/solutions-hebergees/_page.svelte-4c0c75a5.js';
export const imports = ["_app/immutable/components/pages/solutions-hebergees/_page.svelte-4c0c75a5.js","_app/immutable/chunks/index-d33e9054.js","_app/immutable/chunks/index-18b98874.js","_app/immutable/chunks/stores-19b83d6c.js","_app/immutable/chunks/singletons-c1c82277.js","_app/immutable/chunks/CardText-24cd2afa.js"];
export const stylesheets = ["_app/immutable/assets/CardText-ccb86115.css"];
